export default ({ request }) => ({
  // 样品依赖书主表
  proofingInfoListApi(data = {}) {
    return request({
      url: '/master/proofing/info/list',
      method: 'post',
      data,
    })
  },
  proofingInfoSaveApi(data = {}) {
    return request({
      url: '/master/proofing/info/save',
      method: 'post',
      data,
    })
  },
  proofingInfoDetailApi(data = {}) {
    return request({
      url: '/master/proofing/info/detail',
      method: 'post',
      data,
    })
  },
  proofingInfoDelApi(data = {}) {
    return request({
      url: '/master/proofing/info/del',
      method: 'post',
      data,
    })
  },
  proofingInfoAuditApi(data = {}) {
    return request({
      url: '/master/proofing/info/audit',
      method: 'post',
      data,
    })
  },
  // 样品依赖书样品信息主表
  proofingSampleInfoListApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/list',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoDetailApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/detail',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoSaveApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/save',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoBatchSaveApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/batch/save',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoDelApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/del',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoAuditApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/audit',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoCopyApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/copy',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoFinishApi(data = {}) {
    return request({
      url: '/master/proofing/sample/info/finish',
      method: 'post',
      data,
    })
  },
  // 样品依赖书样品图片信息表
  proofingSampleImageListApi(data = {}) {
    return request({
      url: '/master/proofing/sample/image/list',
      method: 'post',
      data,
    })
  },
  proofingSampleImageBatchUploadApi(data = {}) {
    return request({
      url: '/master/proofing/sample/image/batch/upload',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  proofingSampleSetDefaultImageApi(data = {}) {
    return request({
      url: '/master/proofing/sample/image/defaultImage',
      method: 'post',
      data,
    })
  },
  proofingSampleDelApi(data = {}) {
    return request({
      url: '/master/proofing/sample/image/del',
      method: 'post',
      data,
    })
  },
  proofingSampleInfoImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/master/proofing/sample/image/update/sortOrder',
      method: 'post',
      data,
    })
  },
  // 样品依赖书样品物料构成明细表
  proofingSampleMaterialListApi(data = {}) {
    return request({
      url: '/master/proofing/sample/material/list',
      method: 'post',
      data,
    })
  },
  proofingSampleMaterialDetailApi(data = {}) {
    return request({
      url: '/master/proofing/sample/material/detail',
      method: 'post',
      data,
    })
  },
  proofingSampleMaterialSaveApi(data = {}) {
    return request({
      url: '/master/proofing/sample/material/save',
      method: 'post',
      data,
    })
  },
  proofingSampleMaterialDelApi(data = {}) {
    return request({
      url: '/master/proofing/sample/material/del',
      method: 'post',
      data,
    })
  },
  proofingSampleMaterialUpdateSortApi(data = {}) {
    return request({
      url: '/master/proofing/sample/material/updateSort',
      method: 'post',
      data,
    })
  },
  proofingSampleMaterialUpdateCostPriceApi(data = {}) {
    return request({
      url: '/master/proofing/sample/material/update/costPrice',
      method: 'post',
      data,
    })
  },
})
